import React, { useEffect, useState } from 'react'
import { Col, Grid, Row } from 'react-flexbox-grid'
import * as Constants from '../../../../constants'
import { message } from 'antd'
import LoadingPage from '../../../components/LoadingPage'
import { editItemInventory, loadInventory } from '../../../../actions/inventory'
import { getInventory } from '../../../../reducers'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import FormToolInventory from '../../../containers/FormToolInventory'
import './styles.css'

const EditTool = (props) => {
    const [inventoryTool, setInventoryTool] = useState(null)
    const [isSaving, setIsSaving] = useState(false)

    useEffect(() => {
        const pathnameSplited = props?.location?.pathname?.split('/')
        if (pathnameSplited.length === 4) {
            const id = pathnameSplited[3]
            if (props.inventory) {
                if (props.inventory[id]) {
                    setInventoryTool(props.inventory[id])
                } else {
                    message.error('No se encontró el elemento seleccionado')
                    props.history.push(`/${Constants.MenuAdmin.INVENTORY.HOME}`)
                }
            }
        }
    }, [props.inventory])

    const getInventory = () => {
        props.loadInventory()
        return <LoadingPage/>
    }

    const handleSubmitEditTool = async values => {
        setIsSaving(true)
        const response = await props.editItemInventory(values)
        setIsSaving(false)
        if (response) {
            message.success('La herramienta se editó exitósamente')
            props.history.push(`/${Constants.MenuAdmin.INVENTORY.HOME}`)
        } else {
            message.error('Se produjo un error. Por favor, vuelva a intentarlo')
        }
    }

    const handleBack = () => {
        props.history.goBack()
    }

    return (
        <Grid className="editToolCont">
            {
                props.inventory ?
                    <div>
                        <Row center="xs">
                            <Col xs={12}>
                                Editar herramienta - Inventario
                            </Col>
                        </Row>
                        <br/>
                        <Row center="xs">
                            <Col xs={12}>
                                {
                                    inventoryTool ?
                                        <FormToolInventory loading={isSaving}
                                                              onSubmitToolInventory={handleSubmitEditTool}
                                                              isEditing={true} onBack={handleBack}
                                                              toolInventoryToEdit={inventoryTool}/>
                                        :
                                        null
                                }
                            </Col>
                        </Row>
                    </div>
                    :
                    getInventory()
            }
        </Grid>
    )
}

const mapDispatchToPropsActions = dispatch => ({
    loadInventory: value => dispatch(loadInventory(value)),
    editItemInventory: value => dispatch(editItemInventory(value))
})

const mapStateToProps = state => ({
    inventory: getInventory(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(EditTool))
